import {
  Button,
  generateLinkWithParams,
  Link,
  linkPlaceholders,
  routing,
  useAxios,
  useLoginContext,
  useModalContext,
} from "common";
import { useParams } from "react-router-dom";

const ViewOrdersLink = ({ dealByDeal, isAdminUser }) => {
  const { brandId } = useParams();
  const isDisabled = dealByDeal && !isAdminUser;
  return (
    <Link
      to={generateLinkWithParams(routing.crm.viewBrandOrders, {
        [linkPlaceholders.brandId]: brandId,
      })}
    >
      <Button
        fit
        style={{
          fontSize: "1rem",
          opacity: isDisabled ? 0.7 : 1,
          cursor: isDisabled ? "not-allowed" : "pointer",
        }}
        disabled={isDisabled}
      >
        View Orders
      </Button>
    </Link>
  );
};

const RemoveCrmIdModal = ({ brand, onComplete }) => {
  const { callAxios, loading } = useAxios({ onComplete });
  return (
    <div>
      <h3>
        Remove {brand.name} From CRM {brand.crmIds}?
      </h3>
      <Button
        loading={loading}
        onClick={() => {
          console.log("brand.id", brand.id);
          callAxios({ url: `/brands/${brand.id}/removeCrmId`, method: "PUT" });
        }}
      >
        Remove
      </Button>
    </div>
  );
};

const RemoveCrmId = ({ brand, refetch }) => {
  const { setModalContent, closeModal } = useModalContext();
  const { currentUser } = useLoginContext();
  const isCrmRemover = [
    "meilechwieder@gmail.com",
    "hurwitzse@gmail.com",
  ].includes(currentUser?.email);

  if (!isCrmRemover) return null;

  return (
    <Button
      fit
      style={{ fontSize: "0.6rem" }}
      onClick={() =>
        setModalContent(
          <RemoveCrmIdModal
            brand={brand}
            onComplete={() => {
              closeModal();
              refetch();
            }}
          />
        )
      }
    >
      <h3>CRM IDs</h3>
      <div>
        {brand.crmIds?.map((i) => (
          <div key={i}>{i}</div>
        ))}
      </div>
    </Button>
  );
};

const ViewOffersLink = ({ dealByDeal, isAdminUser }) => {
  const { brandId } = useParams();
  const isDisabled = dealByDeal && !isAdminUser;

  return (
    <Link
      to={generateLinkWithParams(routing.crm.viewBrandOffers, {
        [linkPlaceholders.brandId]: brandId,
      })}
    >
      <Button
        fit
        style={{
          fontSize: "1rem",
          opacity: isDisabled ? 0.7 : 1,
          cursor: isDisabled ? "not-allowed" : "pointer",
        }}
        disabled={isDisabled}
        // style={{ fontSize: "1rem" }}
      >
        View Offers
      </Button>
    </Link>
  );
};

const ViewBrandLink = () => {
  const { brandId } = useParams();

  return (
    <Link
      to={generateLinkWithParams(routing.crm.viewBrand, {
        [linkPlaceholders.brandId]: brandId,
      })}
    >
      <Button fit style={{ fontSize: "1rem" }}>
        View Brand
      </Button>
    </Link>
  );
};

const ViewCustomersLink = ({ dealByDeal, isAdminUser }) => {
  const { brandId } = useParams();
  const isDisabled = dealByDeal && !isAdminUser;

  return (
    <Link
      to={generateLinkWithParams(routing.crm.viewBrandCustomers, {
        [linkPlaceholders.brandId]: brandId,
      })}
    >
      <Button
        fit
        style={{
          fontSize: "1rem",
          opacity: isDisabled ? 0.7 : 1,
          cursor: isDisabled ? "not-allowed" : "pointer",
        }}
        disabled={isDisabled}
      >
        {" "}
        View Customers
      </Button>
    </Link>
  );
};

export {
  RemoveCrmId,
  ViewBrandLink,
  ViewCustomersLink,
  ViewOffersLink,
  ViewOrdersLink,
};
